export const DRUO_BANKS: string[] = [
  'Ve por más (BX+)',
  'Banco Azteca',
  'Compartamos Banco',
  'Banco Actinver',
  'CIBanco',
  'Banco BASE',
  'Bankaool',
  'Banco Bancrea',
  'Banco Sabadell',
  'Banco Nacional del Ejército, Fuerza Aérea y Armada',
  'Banco del Bajío',
  'Banco Inbursa',
  'Banco Interacciones',
  'Banca Mifel',
  'Banco Regional de Monterrey',
  'Banco Invex',
  'Banca Afirme',
  'American Express Bank',
  'Bank of America',
  'Banco Multiva',
  'Banco Wal-Mart',
  'Interbanco',
  'Bancoppel',
  'BBVA Bancomer',
  'Banorte',
  'Santander México',
  'HSBC México',
  'Scotiabank México',
  'Citibanamex'
];


export const BANKS = [
  {
    "digito": "002",
    "druo": "ins_b934eb9c-dc8f-47c3-bec5-3a5806e55777",
    "banco": "BANAMEX"
  },
  {
    "digito": "012",
    "druo": "ins_56d425f9-1231-4930-b158-6dfb7157b3a1",
    "banco": "BBVA BANCOMER"
  },
  {
    "digito": "014",
    "druo": "ins_4322eea4-33f8-4234-8c66-9f3e9e0e2f76",
    "banco": "SANTANDER MEXICO"
  },
  {
    "digito": "021",
    "druo": "ins_42aed4bb-a6b1-4f0f-8f4f-015c8e30e73a",
    "banco": "HSBC MÉXICO"
  },
  {
    "digito": "030",
    "druo": "ins_9c90506c-9acd-48b0-8e79-1750dfc89f29",
    "banco": "BANCO DEL BAJIO"
  },
  {
    "digito": "036",
    "druo": "ins_831a37fb-1a9a-4111-a62e-2ee84593cbfa",
    "banco": "BANCO INBURSA"
  },
  {
    "digito": "037",
    "druo": "ins_70b1ff7f-9e02-49e5-91db-b47fbdfa1a96",
    "banco": "BANCO INTERACCIONES"
  },
  {
    "digito": "042",
    "druo": "ins_5460037b-a6f3-4468-bac5-e7968edd72cd",
    "banco": "BANCO MIFEL"
  },
  {
    "digito": "044",
    "druo": "ins_8a5bd509-7537-4b85-9b32-6a89bcd441dd",
    "banco": "SCOTIABANK MÉXICO"
  },
  {
    "digito": "058",
    "druo": "ins_437b3dd6-2b28-42f1-a7df-ec556b5f3306",
    "banco": "BANCO REGIONAL DE MONTERREY"
  },
  {
    "digito": "059",
    "druo": "ins_6ece1cba-20cf-42cf-a5f7-eba84d1ed9b4",
    "banco": "BANCO INVEX"
  },
  {
    "digito": "062",
    "druo": "ins_04669c19-fa3b-4243-b5bd-8a1b16d677b3",
    "banco": "BANCA AFIRME"
  },
  {
    "digito": "103",
    "druo": "ins_f523164e-2c91-48d1-832a-8f2c5fb4f2ad",
    "banco": "AMERICAN EXPRESS BANK (MEXICO)"
  },
  {
    "digito": "106",
    "druo": "ins_21f9f9db-e6a2-4cef-bcee-78fef0f219ee",
    "banco": "BANK OF AMERICA MEXICO"
  },
  {
    "digito": "072",
    "druo": "ins_933fc4c6-02d4-41cd-b7dc-df8108fdc580",
    "banco": "BANORTE"
  },
  {
    "digito": "137",
    "druo": "ins_eb976557-629a-42c0-8413-84c794d0e9ca",
    "banco": "BANCOPPEL, S.A."
  },
  {
    "digito": "113",
    "druo": "ins_5da4a61f-5eae-4ef2-9e6f-483d209360a8",
    "banco": "VE POR MAS (BX+)"
  },
  {
    "digito": "127",
    "druo": "ins_a49d3083-1acf-4c9b-bb2b-e70bfaf934a6",
    "banco": "BANCO AZTECA"
  },
  {
    "digito": "130",
    "druo": "ins_60c283ea-6e2e-4275-be8e-b9c3cd609997",
    "banco": "COMPARTAMOS BANCO"
  },
  {
    "digito": "133",
    "druo": "ins_1e79cc6f-7a53-426a-af51-708637629d58",
    "banco": "BANCO ACTINVER"
  },
  {
    "digito": "143",
    "druo": "ins_5b322c97-7305-4ee3-adc8-753fed228e8d",
    "banco": "CIBANCO"
  },
  {
    "digito": "145",
    "druo": "ins_d0a9bf03-30e1-4d20-9bf4-1fd9d45aeb5f",
    "banco": "BANCO BASE"
  },
  {
    "digito": "019",
    "druo": "ins_c2837867-1cca-420d-b62c-30bd3179b525",
    "banco": "BANCO NACIONAL DEL EJÉRCITO, FUERZA AÉREA Y ARMADA"
  },
  {
    "digito": "132",
    "druo": "ins_d832cb1e-925c-47b1-8b03-c6dc24969af4",
    "banco": "BANCO MULTIVA"
  },
  {
    "digito": "134",
    "druo": "ins_35300621-7b38-416b-9e37-4338af7b280b",
    "banco": "BANCO WAL-MART"
  },
  {
    "digito": "136",
    "druo": "ins_6f8868cf-d1d9-4ccf-a202-57fe3c77657b",
    "banco": "INTERBANCO"
  },
]
